import { Environment } from '../constants/AppConstants';

export interface IGCIPConfig {
  API_KEY: string;
  TENANT_ID: string;
  PROVIDER_ID: string; // OIDC provider ID without the "oidc." prefix
  REDIRECT_SIGN_IN: string;
  REDIRECT_SIGNOUT: string;
}

const REDIRECT_SIGN_IN_MAP: Partial<Record<string, string>> = {
  [Environment.DEV]: 'https://dev.dca.deloitte.com/authenticate',
  [Environment.LOCALHOST]: 'http://localhost:3000/authenticate',
  [Environment.DEMO]: 'https://demo.dca.deloitte.com/authenticate',
  [Environment.PROD]: 'https://www.dca.deloitte.com/authenticate',
};

const REDIRECT_SIGNOUT_MAP: Partial<Record<string, string>> = {
  [Environment.DEV]: 'https://dev.dca.deloitte.com/login',
  [Environment.LOCALHOST]: 'http://localhost:3000/login',
  [Environment.DEMO]: 'https://demo.dca.deloitte.com/login',
  [Environment.PROD]: 'https://www.dca.deloitte.com/login',
};

export const gcipConfiguration = (environment: string): IGCIPConfig => ({
  API_KEY: process.env.REACT_APP_GCIP_API_KEY || '',
  TENANT_ID: process.env.REACT_APP_GCIP_TENANT_ID || '',
  PROVIDER_ID: process.env.REACT_APP_GCIP_PROVIDER_ID || '',
  REDIRECT_SIGN_IN:
    REDIRECT_SIGN_IN_MAP[environment] ?? REDIRECT_SIGN_IN_MAP[Environment.DEV] ?? '',
  REDIRECT_SIGNOUT:
    REDIRECT_SIGNOUT_MAP[environment] ?? REDIRECT_SIGNOUT_MAP[Environment.DEV] ?? '',
});
